import React, { Component } from "react";
import PropTypes from 'prop-types';
import "./ReviewModalWindow.css";

export class ReviewModalWindow extends Component {
  // Handles closing the modal and taking the user to the Failure Review page
  handleClose = () => {
    this.props.closeFunc(); // This function will navigate the user to the Failure Review page
  };

  // Handles retry logic, restarts the submission cycle
  handleRetry = () => {
    this.props.onRetry(); // This will trigger the retry logic in SubmissionCycle.js
  };

  render() {
    if (!this.props.isVisible) {
      return null;
    }

    return (
      <div className="modal-overlay">
        <div className="modal-card">
          <div className="web-appointment-modal__container">
            <h2 className="web-appointment-modal__title">Looks like something went wrong. Try submitting again.</h2>
            <p className="web-appointment-modal__text">
              We're sorry for the inconvenience. Please check your internet connection and try submitting the form again.
            </p>
            <div className="button-input">
              <button className="btn--primary" onClick={this.handleRetry}>Try Again</button>
            </div>
            <div className="button-input">
              <button className="btn--secondary" onClick={this.handleClose}>Close</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReviewModalWindow.propTypes = {
  closeFunc: PropTypes.func.isRequired, // function to handle close action
  onRetry: PropTypes.func.isRequired, // function to handle retry action
  isVisible: PropTypes.bool.isRequired, // controls modal visibility
};

export default ReviewModalWindow;
